"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";

import { Provider } from "react-redux";

import RouteLink from "./routes/RoutesLink";
import { PersistGate } from "redux-persist/integration/react";

//ui states
import ContextStore from "./_context/Store";
import { BrowserRouter } from "react-router-dom";
import MultiTabHandler from "./components/common/MultiTabHandler";
import { UiMainLoader } from "./components/_uiComponents/common/UiMainLoader";
import UiAlert from "./components/_uiComponents/common/UiAlert";

import UiLanguageFonts from "./components/_uiComponents/UiLanguageFonts";
class App extends Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      store: PropTypes.object.isRequired,
    };
  }

  componentDidMount() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("macintosh") || userAgent.includes("mac os")) {
      document.body.classList.add("df-mac");
    } else if (userAgent.includes("windows")) {
      document.body.classList.add("df-windows");
    } else if (userAgent.includes("linux")) {
      document.body.classList.add("df-linux");
    }
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <PersistGate loading={null} persistor={this.props.persistor}>
          <BrowserRouter>
            <ContextStore>
              <UiLanguageFonts>
                <MultiTabHandler />
                <UiMainLoader />
                <UiAlert />
                <RouteLink />
              </UiLanguageFonts>
            </ContextStore>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
